<mat-checkbox class="cb pitka-label" [formField]="valinta" (change)="checkboxChangedEventHandler(valinta().value())">
  @if (order) {
    {{ order }})
  }
  {{ parent + '.' + checkboxField | translatetilinpaatos: 2021 | async }}
</mat-checkbox>
@if (info) {
  <app-icon-button (click)="avaaInfoTeksti(info)" actionId="Avaa infoteksti (liitetiedot)" styles="vertical-align: middle; top: -3px;">
    <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray" aria-hidden="true"></i>
  </app-icon-button>
}
@if (saveSuccess) {
  <span>
    <span class="save-success-text" [@quickInSlowOut]="'in'" style="color: gray"> Arvo tallennettiin </span>
    <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
  </span>
}
<div style="height: 10px">
  @if (saving) {
    <div class="saving" style="height: 10px; width: 100%; padding: 0 33px" [@slowInQuickOut]="'in'">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (saveFailure) {
    <div>
      <span class="save-failure-text"> Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen. </span>
      <mat-icon class="save-failure-icon" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    </div>
  }
</div>
<div style="display: flex">
  @for (f of fields; track f) {
    @if (liitetiedot.valitut[f.field]) {
      <div style="margin-left: 34px; padding-bottom: 10px" [style.width]="70 / fields.length + '%'">
        @if (f.type === 'text') {
          @let teksti = tekstit.kentta(f.field);
          <textarea matInput style="border: 1px dashed gray; padding: 3px; width: 100%; font-family: inherit; font-size: 14px" (blur)="tallennaMuuttunutArvoWithType('text', f.field)" [formField]="teksti" (input)="textChangedEventHandler(f.field, $any($event.target).value)" cdkTextareaAutosize></textarea>
          @if (f.example) {
            <div [innerHTML]="f.example" style="padding: 8px; display: inline-block; color: gray"></div>
          }
        }
        @if (f.type === 'number') {
          @let numero = numerot.kentta(f.field);
          <mat-form-field style="margin-top: 5px">
            <mat-label>{{ f.example }}</mat-label>
            <input class="skip-space-quick-toggle" decimalNumberField #numberField type="text" (blur)="tallennaMuuttunutArvoWithType('number', f.field)" [formField]="numero" (input)="numberChangedEventHandler(f.field, numero().value())" (change)="numberChangedEventHandler(f.field, numero().value())" matInput data-lpignore="true" />
          </mat-form-field>
        }
      </div>
    }
  }
</div>
